import type { MarketsApi } from "@/v2/api/metadata/markets";
import { buildFeedConfigTab } from "@/v2/kits/feed-config";
import { createMarketFeedConfigApi } from "./market-feed-config-api";

/** Saves are inline (toggle / drawer); dialog footer Save is a no-op on this tab. */
export function createFeedConfigTab(marketsApi: MarketsApi) {
  return buildFeedConfigTab(createMarketFeedConfigApi(marketsApi), {
    label: "Feed update configurations",
  });
}
